module.exports = __webpack_public_path__ + "img/trophy.ecd9837d.svg";